import { Injectable, inject } from '@angular/core';
import {
  ApiCreateRuleRequestDto,
  ApiGetRulesResponseDto,
  ApiRuleResponseDto,
  ApiUpdateRuleRequestDto,
  RulesApiService
} from '@birco/rainmesh-api';
import {RuleStateService} from '../api/rule-state-service.interface';
import {Observable} from 'rxjs';
import {RuleFilter} from '../../../features/rules/state/rule.state';
import {HttpResponse} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RuleStateServiceImpl implements RuleStateService {
  private rulesApiService = inject(RulesApiService);


  getRules(options: RuleFilter): Observable<ApiGetRulesResponseDto> {
    return this.rulesApiService.getRules(
      options.pageSize,
      options.page,
      options.sortBy,
      options.sortDir,
      options.searchTerm,
      options.isActive,
      options.isScenarioRule,
      options.deviceId,
    );
  }

  getRuleById(options: { id: string }): Observable<ApiRuleResponseDto> {
    return this.rulesApiService.getRule(options.id)
  }

  createRule(options: { requestDto: ApiCreateRuleRequestDto }): Observable<ApiRuleResponseDto> {
    return this.rulesApiService.createRule(options.requestDto);
  }

  updateRule(options: { ruleId: string, requestDto: ApiUpdateRuleRequestDto }): Observable<ApiRuleResponseDto> {
    return this.rulesApiService.updateRule(options.ruleId, options.requestDto);
  }

  deleteRule(options: { ruleId: string }): Observable<HttpResponse<any>> {
    return this.rulesApiService.deleteRule(options.ruleId);
  }

  updateIsActive(options: { id: string, isActive: boolean }): Observable<ApiRuleResponseDto> {
    return this.rulesApiService.updateIsActive(options.id, {
      isActive: options.isActive
    });
  }
}
